export default "./4a718302573d384b438fc47f8a3c5031.svg";